import React, { FC } from 'react'
import * as pageUtils from './__details.utils'
import { REQUEST_CONFIGS_KEYS } from '@services/constants/requests.constant'
import { RadioList, SelectList } from '@utils/request'
import { formatStrapiText } from '@utils/methods'

const SepticTankFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	const radioListProjectType: RadioList[] = [
		{
			label: pageAssets?.request_form_septicTank_projectType_option1,
			value: '293051000',
			key: 'request_form_septicTank_projectType_option1'
		},
		{
			label: pageAssets?.request_form_septicTank_projectType_option2,
			value: '293051001',
			key: 'request_form_septicTank_projectType_option2'
		},
		{
			label: pageAssets?.request_form_septicTank_projectType_option3,
			value: '293051002',
			key: 'request_form_septicTank_projectType_option3'
		}
	]

	const radioListPropertyType: RadioList[] = [
		{
			label: pageAssets?.request_form_septicTank_propertyType_option1,
			value: '293052000',
			key: 'request_form_septicTank_propertyType_option1'
		},
		{
			label: pageAssets?.request_form_septicTank_propertyType_option2,
			value: '293052001',
			key: 'request_form_septicTank_propertyType_option2'
		}
	]

	const radioListWaterType: RadioList[] = [
		{
			label: pageAssets?.request_form_septicTank_waterType_option1,
			value: '293053000',
			key: 'request_form_septicTank_waterType_option1'
		},
		{
			label: pageAssets?.request_form_septicTank_waterType_option2,
			value: '293053001',
			key: 'request_form_septicTank_waterType_option2'
		},
		{
			label: pageAssets?.request_form_septicTank_waterType_option3,
			value: '293053002',
			key: 'request_form_septicTank_waterType_option3'
		},
		{
			label: pageAssets?.request_form_septicTank_waterType_option4,
			value: '293053003',
			key: 'request_form_septicTank_waterType_option4'
		}
	]

	const getLabelFromList = (list: SelectList[], value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	return (
		<>
			<h4 className={pageUtils.classes.h4}>
				{pageAssets.request_form_septicTank_firstSubStep_title}
			</h4>

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets?.request_form_septicTank_projectType} </b>
				<br />
				{getLabelFromList(
					radioListProjectType,
					request.incidentForm?.projectType
				)}
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets?.request_form_septicTank_propertyType} </b>
				<br />
				{getLabelFromList(
					radioListPropertyType,
					request.incidentForm?.propertyType
				)}
			</p>

			{request.incidentForm?.propertyType?.toString() === '293052000' && (
				<>
					<p className={pageUtils.classes.paragraph}>
						<b>{pageAssets?.request_form_septicTank_propertyBedrooms} </b>
						<br />
						{request.incidentForm?.propertyBedrooms}
					</p>

					<p className={pageUtils.classes.paragraph}>
						<b>{pageAssets?.request_form_septicTank_propertyUnits} </b>
						<br />
						{request.incidentForm?.propertyUnits}
					</p>
				</>
			)}

			{request.incidentForm?.propertyType?.toString() === '293052001' && (
				<>
					<p className={pageUtils.classes.paragraph}>
						<b>{pageAssets?.request_form_septicTank_propertyFlowRate} </b>
						<br />
						{request.incidentForm?.propertyFlowRate}
					</p>
				</>
			)}

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets?.request_form_septicTank_propertyWaterSource} </b>
				<br />
				{getLabelFromList(
					radioListWaterType,
					request.incidentForm?.propertyWaterSource
				)}
			</p>
		</>
	)
}

export default SepticTankFormDetails
